// ── Shared utilities ──────────────────────────────────────────

export const TODAY = new Date(); TODAY.setHours(0,0,0,0)
export const addDays = (d,n) => { const r=new Date(d); r.setDate(r.getDate()+n); return r }
export const fmt = d => d ? new Date(d).toLocaleDateString('en-US',{month:'short',day:'numeric',year:'numeric'}) : '—'
export const fmtShort = d => d ? new Date(d).toLocaleDateString('en-US',{month:'short',day:'numeric'}) : '—'
export const fmtInput = d => { const dt=new Date(d); return `${dt.getFullYear()}-${String(dt.getMonth()+1).padStart(2,'0')}-${String(dt.getDate()).padStart(2,'0')}` }

export function getInterval(u, season) { return season==='winter' ? u.winter_interval??null : u.summer_interval }
export function getStatus(u, season) {
  const iv=getInterval(u,season)
  if(!iv) return {label:'OFF',color:'#8896a8',bg:'#f0f2f5',days:null}
  if(!u.last_changed) return {label:'NO DATE',color:'#8896a8',bg:'#f0f2f5',days:null}
  const due=addDays(new Date(u.last_changed),iv), days=Math.round((due-TODAY)/864e5)
  if(days<0)  return {label:'OVERDUE', color:'#c0392b',bg:'#fdecea',days}
  if(days<=3) return {label:'DUE SOON',color:'#d35400',bg:'#fef0e6',days}
  if(days<=7) return {label:'UPCOMING',color:'#b7860b',bg:'#fefae6',days}
  return         {label:'OK',          color:'#1e8449',bg:'#eafaf1',days}
}
export function getStockStatus(i) {
  if(i.stock===0)            return {label:'OUT OF STOCK', color:'#c0392b',bg:'#fdecea'}
  if(i.stock<i.min_stock)   return {label:'LOW — REORDER',color:'#d35400',bg:'#fef0e6'}
  if(i.stock===i.min_stock) return {label:'AT MINIMUM',   color:'#b7860b',bg:'#fefae6'}
  return                           {label:'OK',           color:'#1e8449',bg:'#eafaf1'}
}
export const C={navy:'#0f2237',blue:'#1a3d5c',steel:'#2d6a9f',bg:'#f4f6f9',card:'#fff',border:'#e2e8f0',text:'#1e2a3a',muted:'#6b7c93'}
export const TH={padding:'8px 12px',fontWeight:700,fontSize:11,color:C.muted,textTransform:'uppercase',letterSpacing:'.06em',borderBottom:`1px solid ${C.border}`,background:'#f8fafc',whiteSpace:'nowrap'}
export const TD={padding:'9px 12px',fontSize:12,color:C.text,borderBottom:`1px solid ${C.border}`}

export const BUILDING_MAP = {
  'Big Shul Unit #1':'Big Shul','Big Shul Unit #2':'Big Shul','Big Shul Unit #3':'Big Shul',
  'Big Shul Unit #4':'Big Shul','Big Shul Unit #5':'Big Shul','Big Shul Unit #6':'Big Shul',
  'Big Shul Unit #7':'Big Shul','Big Shul Unit #8':'Big Shul','Big ShulUnit #1':'Big Shul',
  '2nd FL Shul Office':'Big Shul','Kiddush Room X 3':'Big Shul','Ladies Entrance 48 St':'Big Shul',
  'Beis Horuah':'Big Shul','Air Handler':'Coffee Room','Old Shul unit':'Old Shul','Old Shul':'Old Shul',
  'Rabbi Room':'Rabbi Room','Cheder Daled':'Cheder Daled','Mishnas Yonah':'Mishnas Yonah',
  'Cheder Schlaff':'Cheder Schlaff','Schlaff Office':'Cheder Schlaff',
  'New Extension - 47 St':'47th Street',
  'Sukah Unit #1':'Sukah','Sukah Unit #2':'Sukah','Sukah Unit #3':'Sukah',
  'Sukah Unit #4':'Sukah','Sukah Unit #5':'Sukah','Sukah Unit #6':'Sukah',
  'Sukah Unit #7':'Sukah','Ladies Sukah':'Sukah',
  '15 Ave Lobby Entrance':'Main Entrance',
  'Mikva 15 Ave Side':'Mikva','Mikva 16 Ave Side':'Mikva',
  'Pulish':'Pulish','Obstfeld Front':'Pulish','Obstfeld Back':'Pulish',
  'Pulish Front':'Pulish','Pulish Back':'Pulish',
  'New Kolel Basement':'New Kolel','Basement Bathrooms':'Basement',
}
export function getBuilding(area) { return BUILDING_MAP[area] || area }

export function exportToCSV(rows,filename) {
  if(!rows.length) return
  const keys=Object.keys(rows[0])
  const csv=[keys.join(','),...rows.map(r=>keys.map(k=>JSON.stringify(r[k]??'')).join(','))].join('\n')
  const a=document.createElement('a'); a.href=URL.createObjectURL(new Blob([csv],{type:'text/csv'})); a.download=filename; a.click()
}

// QR code generator using qrcode.js CDN
export function generateQRDataURL(text) {
  return `https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${encodeURIComponent(text)}`
}

// Print utilities
export function printHTML(html) {
  const w = window.open('','_blank')
  w.document.write(html)
  w.document.close()
  w.focus()
  setTimeout(()=>{w.print()},500)
}
